<template>
  <div class="footer-editor">
    <!-- テキストエディタ -->
    <template v-if="showTabContent">
      <div v-for="part in parts" :key="part.table_id">
        <tiny-mce-editor
          class="tinymceEditor"
          v-if="part.table_id === current.tableId"
          v-model="part.body"
          :isCodePart="false"
          :sectionId="sectionId"
          :partsContainerId="partsContainerId"
          :partId="part.id"
          :codePartNodeIndex="null"
          :extTypeName="extTypeName"
        />
      </div>
    </template>
    <!-- スタイル設定 -->
    <template v-if="showTabStyle">
      <div v-for="part in parts" :key="part.table_id">
        <edit-text-style
          v-if="part.table_id === current.tableId"
          v-model="part.styles"
          :sectionId="sectionId"
          :partsContainerId="partsContainerId"
          :partId="part.id"
          :partsContainerType="partsContainerType"
          :partsContainerStyles="partsContainerStyles"
        />
      </div>
    </template>
    <!-- レイアウト -->
    <edit-column-setting
      v-if="showTabSetting"
      :sectionId="sectionId"
      :partsContainerId="partsContainerId"
      :partsContainerType="partsContainerType"
      :partsContainerStyles="partsContainerStyles"
      :spacerParts="spacerParts"
      :columnCount="columnCount"
      :flgSide="flgSide"
      @adjustCurrentTableId="$emit('adjustCurrentTableId', $event)"
    />
  </div>
</template>

<script>
import EditTextStyle from '@/components/Content/Palette/EditPartDesign/Layouts/StyleTab/TextStyle'
import EditColumnSetting from '@/components/Content/Palette/EditPartDesign/Layouts/ColumnSetting'
import TinyMceEditor from '@/components/Content/Palette/EditPartDesign/Editor/TinyMceEditor'

export default {
  props: [
    'current',
    'parts',
    'sectionId',
    'partsContainerId',
    'partsContainerType',
    'partsContainerStyles',
    'columnCount',
    'flgSide',
    'extTypeName',
  ],
  components: {
    EditTextStyle,
    EditColumnSetting,
    TinyMceEditor,
  },
  computed: {
    showTabContent () {
      return this.current.tab === 'Content'
    },
    showTabStyle () {
      return this.current.tab === 'Style'
    },
    showTabSetting () {
      return this.current.tab === 'Setting'
    },
    spacerParts () {
      if (!this.parts) return null
      return this.parts.filter(part => part.type === 'Spacer')
    }
  },
}
</script>
